// Use `||` not `??`: the production .env defines these as empty strings, and
// `??` would let `''` through — making `${UPLOADER_BASE}/upload` a same-origin
// relative request that 405s against the API worker. Empty must fall back too.
const UPLOADER_BASE =
  (import.meta.env.VITE_UPLOADER_BASE as string | undefined) ||
  'https://file-uploader.benchmetrics.workers.dev';
const UPLOADER_API_KEY =
  (import.meta.env.VITE_UPLOADER_API_KEY as string | undefined) ||
  'benchmetrics-3dc3c222-64ab-4d44-abd5-84f648e1d8af';

export type UploadResult = { url: string; image_id: string };

export async function uploadFile(file: File): Promise<UploadResult> {
  const fd = new FormData();
  fd.append('files', file);
  const res = await fetch(`${UPLOADER_BASE}/upload`, {
    method: 'POST',
    body: fd,
    headers: { 'x-api-key': UPLOADER_API_KEY },
  });
  if (!res.ok) throw new Error(`Upload failed: ${res.status}`);
  const data = (await res.json()) as Array<{
    imageUrl?: string;
    fileUrl?: string;
    imageId?: string;
    fileId?: string;
  }>;
  const first = data[0];
  if (!first) throw new Error('Upload returned no entry');
  const url = first.imageUrl ?? first.fileUrl;
  const image_id = first.imageId ?? first.fileId;
  if (!url || !image_id) throw new Error('Upload missing url/id');
  return { url, image_id };
}

export async function uploadFiles(
  files: File[],
  onProgress?: (done: number, total: number) => void,
): Promise<UploadResult[]> {
  const results: UploadResult[] = [];
  for (let i = 0; i < files.length; i += 1) {
    const f = files[i];
    if (!f) continue;
    results.push(await uploadFile(f));
    onProgress?.(i + 1, files.length);
  }
  return results;
}
